

























import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  Ref,
  ref,
  useStore,
  reactive,
} from '@nuxtjs/composition-api'
import { debounce } from 'throttle-debounce'
export default defineComponent({
  name: 'SectionProlongationGrid',
  setup() {
    const store = useStore()
    const isMobile = computed(() => store.getters['mediaQuery/isMobileMq'])
    const isScrolled: Ref<boolean> = ref(false)
    const formProps = reactive({
      left: 0,
      width: 0,
    })
    const onScroll = debounce(10, (e: Event) => {
      const el = e.target.scrollingElement
      if (el.scrollTop === 0) isScrolled.value = false
      if (!isScrolled.value && el.scrollTop) isScrolled.value = true
    })
    if (process.browser) {
      onMounted(() => {
        window.addEventListener('scroll', onScroll)
        const formElement: HTMLDivElement = document.querySelector(
          '#block-form-container .form'
        )
        formProps.left =
          formElement.offsetLeft + formElement.offsetParent.offsetLeft
        formProps.width = formElement.offsetWidth
      })
      onUnmounted(() => {
        window.removeEventListener('scroll', onScroll)
      })
    }

    return {
      formProps,
      isMobile,
      isScrolled,
    }
  },
})
